import { appShare, initWechatShare } from "@/utils/share";
import { openPage, isZyapp,isIOS} from "@/utils/modulesForApp";
import i18n from "@/i18n/index";

// 为了用openPage打开富文本里的a标签所写的沙雕方法
window.openUrl = url => {
    if (isZyapp()) {
        openPage({
            url
        });
    } else {
        window.location.href = url;
    }
};

export default {
    share(title) {
        appShare({
            title: title,
            img: "http://resource.cmbi.info/%E5%A3%B9%E9%9A%86%E7%8E%AF%E7%90%83_logo.png",
            summary: i18n.t("common.share"),
            url: window.location.href,
        });
        
    },
    wecatShare(title) {
        initWechatShare({
            title: title,
            img: "http://resource.cmbi.info/%E5%A3%B9%E9%9A%86%E7%8E%AF%E7%90%83_logo.png",
            summary: i18n.t("common.share"),
            url: window.location.href,
        })
    },
    // 把富文本的a标签跳转替换成openPage的方式跳转
    transferJumpMode(str) {
        const s = str.replace(/<a.*?>/gi, m => {
            const reg = /<a([\s]+|[\s]+[^<>]+[\s]+)(href|id)=(\"([^<>"\']*)\"|\'([^<>"\']*)\')[^<>]*>/gi;
            const regList = m.match(reg);
            let url='';
            let id ='';
            let href = RegExp.$4;
            // console.log(RegExp.$2=='id','regList：',RegExp.$2,RegExp.$3,RegExp.$4)
            if(RegExp.$2=='id'){
                id= href;
            }else{
                url = href;
            }
            if (url.indexOf("tel:") === 0 || url.indexOf("mailto:") === 0) {
                // 电话或者邮箱
                return `<span href="${url}" style="color: #3D7EFF" onClick="location.href = '${url}'" >`;
            }
            if(url.indexOf('#')!=-1){
                return `<span style="color: #3D7EFF" onClick="(()=>{ document.getElementById('${url.slice(url.indexOf('#')+1)}').scrollIntoView(true) })()">`;
            }
            if(id!=''){
                return `<span id="${id}" style="color: #3D7EFF" onClick="openUrl('${url}')">`;
            }
            return `<span style="color: #3D7EFF" onClick="openUrl('${url}')">`;
        });
        return s.replace(/<\/a>/g, "</span>");
    },
    // 转换路由标题
    switchLanguage(that, key) {
        if (!key) return "";
        const hasKey = that.$te(key);
        if (hasKey) {
            return that.$t(key);
        }
        return "";
    },
    // 是否为ios端
    getIsIOS(){
        return isIOS()
    }
}